document.addEventListener("DOMContentLoaded", () => {
  
  // 1. AJAX QUICK ADD SYSTEM
  const initializeQuickAdd = () => {
    const sizeButtons = document.querySelectorAll(".quick-add-size-btn");
    const directButtons = document.querySelectorAll(".quick-add-direct-btn");

    const handleAdd = (button, variantId) => {
      if (button.classList.contains("loading")) return;
      
      const originalText = button.innerHTML;
      button.classList.add("loading");
      button.disabled = true;
      button.innerHTML = "ADDING...";

      // AJAX Request to Shopify add-to-cart endpoint
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(res => {
        if (!res.ok) throw new Error("Could not add product to cart");
        return res.json();
      })
      .then(data => {
        button.innerHTML = "ADDED";
        button.style.backgroundColor = "#FFFFFF";
        button.style.color = "#000000";
        
        // Refresh Cart Count Badges on page
        return fetch("/cart.js");
      })
      .then(res => res.json())
      .then(cart => {
        const badges = document.querySelectorAll(".cart-count-badge");
        badges.forEach(badge => {
          badge.textContent = `(${cart.item_count})`;
        });
      })
      .catch(err => {
        console.error("AJAX Quick Add error:", err);
        button.innerHTML = "ERROR";
      })
      .finally(() => {
        setTimeout(() => {
          button.classList.remove("loading");
          button.disabled = false;
          button.innerHTML = originalText;
          button.style.backgroundColor = "";
          button.style.color = "";
        }, 1500);
      });
    };

    sizeButtons.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const variantId = btn.getAttribute("data-variant-id");
        handleAdd(btn, variantId);
      });
    });

    directButtons.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const variantId = btn.getAttribute("data-variant-id");
        handleAdd(btn, variantId);
      });
    });
  };

  initializeQuickAdd();

  // 3. PRODUCT DETAIL PAGE SIZE SELECTOR
  const initializeProductPageSizes = () => {
    const sizeBtns = document.querySelectorAll(".product-size-btn");
    const variantInput = document.getElementById("selected-variant-id");

    if (sizeBtns.length > 0 && variantInput) {
      sizeBtns.forEach(btn => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          sizeBtns.forEach(b => b.classList.remove("selected"));
          btn.classList.add("selected");
          const variantId = btn.getAttribute("data-variant-id");
          variantInput.value = variantId;
        });
      });
    }
  };

  initializeProductPageSizes();

  // 2. GSAP SCROLL & LUXURY NEWSLETTER ENGINE
  if (typeof gsap !== 'undefined') {
    if (typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
    }

    const mm = gsap.matchMedia();

    // DESKTOP PARALLAX MOTION: Runs only on viewports larger than 767px
    mm.add("(min-width: 768px)", () => {
      const layers = document.querySelectorAll("[data-speed]");
      layers.forEach((layer) => {
        const speed = parseFloat(layer.getAttribute("data-speed"));
        
        gsap.to(layer, {
          y: () => (1 - speed) * ScrollTrigger.maxScroll(window) * 0.1,
          ease: "none",
          scrollTrigger: {
            trigger: layer.closest('.depth-section'),
            start: "top bottom",
            end: "bottom top",
            scrub: 1.2 // High smoothing factor for dynamic liquid feel
          }
        });
      });
    });

    // ALL SCREENS: Full-screen Dialog Newsletter Management
    const modal = document.getElementById("editorial-newsletter-modal");
    const closeBtn = document.querySelector(".newsletter-modal-close");
    const modalInner = document.querySelector(".newsletter-modal-inner");

    if (modal && modalInner) {
      let modalOpened = false;

      const openNewsletterModal = () => {
        if (modalOpened || localStorage.getItem('spectrum_newsletter_dismissed') === 'true') return;
        
        // Prevent launching modal if customer is active in standard inputs
        const activeEl = document.activeElement;
        if (activeEl && (activeEl.tagName === 'INPUT' || activeEl.tagName === 'TEXTAREA')) return;
        
        modalOpened = true;
        modal.showModal();

        // Stagger elements entry with GSAP
        const timeline = gsap.timeline();
        timeline.fromTo(modalInner,
          { opacity: 0, y: 30 },
          { opacity: 1, y: 0, duration: 0.7, ease: "power3.out" }
        );
        timeline.fromTo(modalInner.querySelectorAll(".editorial-mono-tag, h3, p, .minimalist-newsletter-form"),
          { opacity: 0, y: 15 },
          { opacity: 1, y: 0, duration: 0.5, stagger: 0.12, ease: "power2.out" },
          "-=0.4"
        );
      };

      const closeNewsletterModal = () => {
        localStorage.setItem('spectrum_newsletter_dismissed', 'true');
        gsap.to(modalInner, {
          opacity: 0,
          y: 20,
          duration: 0.4,
          ease: "power2.in",
          onComplete: () => {
            modal.close();
          }
        });
      };

      if (closeBtn) closeBtn.addEventListener("click", closeNewsletterModal);
      
      // Close on backdrop click (clicks outside the inner content panel)
      modal.addEventListener("click", (e) => {
        if (!modalInner.contains(e.target) && e.target !== closeBtn) {
          closeNewsletterModal();
        }
      });

      // Cleanup key events
      modal.addEventListener("cancel", (e) => {
        e.preventDefault();
        closeNewsletterModal();
      });

      // Trigger 1: 60% Scroll Depth on Homepage
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.create({
          trigger: "body",
          start: "60% top",
          onEnter: () => {
            openNewsletterModal();
          }
        });
      }

      // Trigger 2: Exit Intent (Mouse moves out of top viewport)
      document.addEventListener("mouseleave", (e) => {
        if (e.clientY < 20) {
          openNewsletterModal();
        }
      });
    }
  }
});